// ISO country list with dial codes — default: Angola
// Flag emojis are composed from country code letters.

const rawCountries = [
  ["AO", "Angola", "244"],
  ["PT", "Portugal", "351"],
  ["BR", "Brasil", "55"],
  ["MZ", "Moçambique", "258"],
  ["CV", "Cabo Verde", "238"],
  ["GW", "Guiné-Bissau", "245"],
  ["ST", "São Tomé e Príncipe", "239"],
  ["TL", "Timor-Leste", "670"],
  ["ES", "España", "34"],
  ["FR", "France", "33"],
  ["DE", "Deutschland", "49"],
  ["IT", "Italia", "39"],
  ["NL", "Nederland", "31"],
  ["BE", "Belgique", "32"],
  ["CH", "Schweiz", "41"],
  ["AT", "Österreich", "43"],
  ["SE", "Sverige", "46"],
  ["NO", "Norge", "47"],
  ["DK", "Danmark", "45"],
  ["FI", "Suomi", "358"],
  ["PL", "Polska", "48"],
  ["CZ", "Česko", "420"],
  ["GB", "United Kingdom", "44"],
  ["IE", "Ireland", "353"],
  ["US", "United States", "1"],
  ["CA", "Canada", "1"],
  ["MX", "México", "52"],
  ["AR", "Argentina", "54"],
  ["CL", "Chile", "56"],
  ["CO", "Colombia", "57"],
  ["PE", "Perú", "51"],
  ["UY", "Uruguay", "598"],
  ["VE", "Venezuela", "58"],
  ["EC", "Ecuador", "593"],
  ["BO", "Bolivia", "591"],
  ["PY", "Paraguay", "595"],
  ["RU", "Russia", "7"],
  ["UA", "Ukraine", "380"],
  ["TR", "Türkiye", "90"],
  ["CN", "中国 China", "86"],
  ["JP", "日本 Japan", "81"],
  ["KR", "대한민국 Korea", "82"],
  ["IN", "भारत India", "91"],
  ["PK", "Pakistan", "92"],
  ["BD", "Bangladesh", "880"],
  ["TH", "ประเทศไทย", "66"],
  ["VN", "Việt Nam", "84"],
  ["ID", "Indonesia", "62"],
  ["MY", "Malaysia", "60"],
  ["SG", "Singapore", "65"],
  ["PH", "Philippines", "63"],
  ["AE", "الإمارات", "971"],
  ["SA", "السعودية", "966"],
  ["QA", "قطر", "974"],
  ["KW", "الكويت", "965"],
  ["OM", "عُمان", "968"],
  ["BH", "البحرين", "973"],
  ["IL", "ישראל", "972"],
  ["EG", "مصر", "20"],
  ["MA", "المغرب", "212"],
  ["TN", "تونس", "216"],
  ["DZ", "الجزائر", "213"],
  ["ZA", "South Africa", "27"],
  ["NG", "Nigeria", "234"],
  ["KE", "Kenya", "254"],
  ["ET", "Ethiopia", "251"],
  ["GH", "Ghana", "233"],
  ["CI", "Côte d'Ivoire", "225"],
  ["SN", "Sénégal", "221"],
  ["CM", "Cameroun", "237"],
  ["CD", "RD Congo", "243"],
  ["CG", "Congo", "242"],
  ["GA", "Gabon", "241"],
  ["NA", "Namibia", "264"],
  ["ZM", "Zambia", "260"],
  ["ZW", "Zimbabwe", "263"],
  ["MW", "Malawi", "265"],
  ["TZ", "Tanzania", "255"],
  ["UG", "Uganda", "256"],
  ["RW", "Rwanda", "250"],
  ["BW", "Botswana", "267"],
  ["AU", "Australia", "61"],
  ["NZ", "New Zealand", "64"],
];

// Convert ISO code to regional indicator flag emoji
const flag = (iso) =>
  String.fromCodePoint(...[...iso.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));

export const COUNTRIES = rawCountries
  .map(([iso, name, dial]) => ({ iso, name, dial, flag: flag(iso) }))
  .sort((a, b) => {
    if (a.iso === "AO") return -1;
    if (b.iso === "AO") return 1;
    return a.name.localeCompare(b.name);
  });

export const DEFAULT_DIAL = "244"; // Angola
